import { Link } from 'react-router-dom';
import { IoLogOutOutline } from 'react-icons/io5';
import { DarkMode } from '@/components/ui/DarkMode';
import { FullscreenButton } from '@/components/ui/FullscreenButton';
import { useAuthContext } from '@/features/auth/providers/AuthProvider';
import VerticalSeparator from '@/components/ui/base/VerticalSeparator';
import { TutorialButton } from '@/components/Tutorial/TutorialButton';
// import { useState, useRef, useEffect } from 'react';
// import { FaChevronDown } from 'react-icons/fa6';

interface NavbarProps {
  className?: string;
  hidden?: boolean;
}

export const Navbar = ({ className = '', hidden = false }: NavbarProps) => {
  const { isAuthenticated, logout } = useAuthContext();
  // const [isToolsOpen, setIsToolsOpen] = useState(false);
  // const menuRef = useRef<HTMLDivElement>(null);
  // const timeoutRef = useRef<NodeJS.Timeout>();

  // // const handleMouseEnter = () => {
  // //   if (timeoutRef.current) {
  // //     clearTimeout(timeoutRef.current);
  // //   }
  // //   setIsToolsOpen(true);
  // // };

  // // const handleMouseLeave = () => {
  // //   timeoutRef.current = setTimeout(() => {
  // //     setIsToolsOpen(false);
  // //   }, 100); // Petit délai pour permettre le passage de la souris entre le bouton et le menu
  // // };

  // useEffect(() => {
  //   return () => {
  //     if (timeoutRef.current) {
  //       clearTimeout(timeoutRef.current);
  //     }
  //   };
  // }, []);

  const siteVersion = import.meta.env.VITE_FRAUD_VERSION || '1.0';

  return (
    <header
      className={`flex h-14 bg-neutralBG px-6 dark:bg-neutralBG-dark md:px-8 ${className} ${hidden ? 'hidden' : ''}`}
    >
      <div className="flex w-full justify-between">
        <div className="flex items-center gap-6">
          <span className="flex h-8 items-center text-xl md:text-xl lg:text-2xl">
            <Link
              className="text-xl text-neutralText dark:text-neutralText-dark"
              to="/"
            >
              doc<span className="font-semibold">Teller</span>
            </Link>
          </span>
          <VerticalSeparator />
          <nav>
            <ul className="hidden md:flex md:items-center md:gap-6">
              <li className="font-ocr text-xs text-neutralText opacity-80 dark:text-neutralText-dark">
                V{siteVersion}
              </li>
            </ul>
          </nav>
        </div>
        <div className="flex items-center gap-6">
          {/*{
          isAuthenticated && (
            <div className="relative" ref={menuRef}>
              <button
                className="flex items-center gap-2 text-neutralText hover:text-primary dark:text-neutralText-dark dark:hover:text-primary"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                Outils
                <FaChevronDown
                  className={`text-sm transition-transform ${
                    isToolsOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {isToolsOpen && (
                <div
                  className="absolute left-0 top-full mt-2 w-48 rounded-md bg-neutralBG p-2 shadow-lg dark:bg-neutralBG-dark"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <Link
                    to="/tools/rib-reader"
                    className="block rounded-md px-4 py-2 text-sm text-neutralText hover:bg-neutralBG2 dark:text-neutralText-dark dark:hover:bg-neutralBG2-dark"
                    onClick={() => setIsToolsOpen(false)}
                  >
                    Lecture de RIB
                  </Link>
                  <Link
                    to="/tools/phone-operator"
                    className="block rounded-md px-4 py-2 text-sm text-neutralText hover:bg-neutralBG2 dark:text-neutralText-dark dark:hover:bg-neutralBG2-dark"
                    onClick={() => setIsToolsOpen(false)}
                  >
                    Opérateur téléphonique
                  </Link>
                  <Link
                    to="/tools/image-analysis"
                    className="block rounded-md px-4 py-2 text-sm text-neutralText hover:bg-neutralBG2 dark:text-neutralText-dark dark:hover:bg-neutralBG2-dark"
                    onClick={() => setIsToolsOpen(false)}
                  >
                    Analyse d'image
                  </Link>
                </div>
              )}
            </div>
          )}*/}
          {isAuthenticated && (
            <>
              <FullscreenButton />
              <TutorialButton />
              <DarkMode />
              <button
                onClick={logout}
                className="flex items-center rounded-md bg-[#cc2323] p-[10px] text-sm font-medium text-neutralBG shadow-md transition-all duration-100 hover:bg-[#ee4242] dark:text-neutralBG"
              >
                <IoLogOutOutline className="text-lg" />
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
